import { Typography } from '@achieve/ascend'

export const DatSubTitle = ({
  title = 'Here’s your estimated debt summary based on your credit card balance:',
  ...props
}) => {
  return (
    <Typography variant="bodySm" data-testid="dat-subtitle" id="subtitle" {...props}>
      {title}
    </Typography>
  )
}
